import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getNotification,
  Notification,
  NotificationReadStatus,
} from '../../../api/v1/message'

export const getNotificationAction = createAsyncThunk<
  Notification[],
  | {
      page?: number
      limit?: number
      status?: NotificationReadStatus
    }
  | undefined
>('app/getNotificationAction', async ({ page, limit, status } = {}) => {
  page = page ?? 0
  limit = limit ?? 100
  status = NotificationReadStatus.All
  const r = await getNotification(page, limit, status)

  return r.data.records
})
export const incrementalNotificationAction = createAction<Notification[]>(
  'app/incrementalNotificationAction'
)
export const updateNotificationAction = createAction<Notification[]>(
  'app/updateNotificationAction'
)
